import { redirect } from '@tanstack/react-router'
import type { RouterContext } from '@/router-context'

export function requirePermission(context: RouterContext, permission?: string) {
  if (permission && !context.auth.permissions.includes(permission)) {
    throw redirect({ to: '/unauthorized' })
  }
}
